import React, { createContext, useContext, useState, useEffect, useRef } from "react";
import axios from "axios";

const BlogUpdateContext = createContext();

export const useBlogUpdate = () => useContext(BlogUpdateContext);

export const BlogUpdateProvider = ({ children }) => {

  const [popup, setPopup] = useState({ open: false, type: "success", message: "" });
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState(null);
  const [errors, setErrors] = useState({});
  const [slug,setSlug]=useState(null)
  const refs = useRef({});

  // 🧩 Fetch existing blog by slug
  useEffect(() => {
    async function fetchBlogBySlug() {
      try {
        const { data } = await axios.get(
          `https://parcharmanch-backend-7kc7.onrender.com/parcharmanch/getBlogBySlug/${slug}`
        );

        if (data.blog) {
          const b = data.blog;

          const contentArray =
            b.Content && b.Content.length > 0
              ? b.Content.map((c) => ({
                  html: c.content || "",
                  img: c?.img?.url || null,
                  altText: (c.img && c.img.altText) || "",
                }))
              : [{ html: "", img: null, altText: "" }];

          setFormData({
            HeroImg: b.HeroImg?.url || null,
            HeroAltText: b.HeroAltText || "",
            Category: b.Category || "",
            SubCategory: b.SubCategory || "",
            Tags: b.Tags || "",
            Title: b.Title || "",
            Subtitle: b.Subtitle || "",
            Slug: b.Slug || "",
            MetaTitle: b.MetaTitle || "",
            MetaDescription: b.MetaDescription || "",
            MetaKeywords: Array.isArray(b.MetaKeywords)
              ? b.MetaKeywords.join(", ")
              : "",
            Content: contentArray,
            FAQs: b.FAQs && b.FAQs.length > 0 ? b.FAQs : [{ Q: "", A: "" }],
             status: b.status || "draft", // 🟢 add this line
           Date: b.Date
  ? new Date(b.Date).toISOString().slice(0, 16) // ✅ converts to 2025-11-08T09:30
  : "",
          });
        } else {
            // console.log("else execute");
            
          setPopup({ open: true, type: "error", message: "Blog not found by slug" });
        }
      } catch (error) {
        setPopup({ open: true, type: "error", message: "Error fetching blog data" });
      }
    }
     if(slug)
    fetchBlogBySlug();
  }, [slug]);

  // 🧩 Input Change Handler
  const handleInputChange = (e, index, field) => {
    // console.log("input change handler");
    const { name, value } = e.target;
    if (field === "Content") {
      const updated = [...formData.Content];
      updated[index][name] = value;
      setFormData({ ...formData, Content: updated });
    } else if (field === "FAQs") {
      const updated = [...formData.FAQs];
      updated[index][name] = value;
      setFormData({ ...formData, FAQs: updated });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  // 🧩 Image & Editor Handlers
  const handleImageChange = (e, index, field) => {
    const file = e.target.files[0];
    if (field === "HeroImg") {
      setFormData({ ...formData, HeroImg: file });
    } else if (field === "Content") {
      const updated = [...formData.Content];
      updated[index].img = file;
      setFormData({ ...formData, Content: updated });
    }
  };

  const handleEditorChange = (value, index) => {
    const updated = [...formData.Content];
    updated[index].html = value;
    setFormData({ ...formData, Content: updated });
  };

  const handleAddContent = () => {
    setFormData({
      ...formData,
      Content: [...formData.Content, { html: "", img: null, altText: "" }],
    });
  };
  const handleAltTextChange = (e, index) => {
  const value = e.target.value;

  setFormData((prev) => {
    const updatedContent = [...prev.Content];
    updatedContent[index].altText = value;
    return { ...prev, Content: updatedContent };
  });
};


  const handleDeleteContent = (index) => {
  setFormData((prev) => ({
    ...prev,
    Content: prev.Content.filter((_, i) => i !== index),
  }));
};

  const handleAddFAQ = () => {
    setFormData({
      ...formData,
      FAQs: [...formData.FAQs, { Q: "", A: "" }],
    });
  };

  const handleDeleteFAQ = (index) => {
  setFormData((prev) => ({
    ...prev,
    FAQs: prev.FAQs.filter((_, i) => i !== index),
  }));
};
  // 🧩 Validation
  const validateForm = () => {
    const newErrors = {};
    if (!formData.HeroAltText.trim())
      newErrors.HeroAltText = "Please enter alt text for hero image";

    const requiredFields = [
      "Category",
      "SubCategory",
      "Title",
      "Subtitle",
      "Tags",
      "Slug",
      "MetaTitle",
      "MetaDescription",
      "MetaKeywords",
      // "Date",
    ];
    requiredFields.forEach((field) => {
      if (!formData[field] || formData[field].trim() === "") {
        newErrors[field] = `Please fill the ${field}`;
      }
    });

    if (formData.status === "scheduled") {
    if (!formData.Date || formData.Date.trim() === "") {
      newErrors.Date = "Please select scheduled date";
    }
  }
    
    //  console.log("🔍 Validation Errors:", newErrors); // 👈 ADD THIS LINE

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // 🧩 Update Blog Function
  const handleUpdateBlog = async () => {
            // console.log("api call")

    if (!validateForm()) {
        // console.log("validation fail");
        
        return;
    }
    setLoading(true);

    try {
        // console.log("api call")
      const form = new FormData();
      if (formData.HeroImg && formData.HeroImg instanceof File)
        form.append("HeroImg", formData.HeroImg);

      form.append("HeroAltText", formData.HeroAltText);
      [
        "Category",
        "SubCategory",
        "Title",
        "Subtitle",
        "Tags",
        "Slug",
        "Date",
        "MetaTitle",
        "MetaDescription",
        "MetaKeywords",
      ].forEach((key) => form.append(key, formData[key]));

      const contentToSend = formData.Content.map((c) => ({
        content: c.html,
        altText: c.altText,
      }));
      form.append("Content", JSON.stringify(contentToSend));

      formData.Content.forEach((c, i) => {
        if (c.img && c.img instanceof File) {
          form.append(`ContentImg_${i}`, c.img);
        }
      });

      form.append("FAQs", JSON.stringify(formData.FAQs));
      form.append("status", formData.status);


      // console.log("form",form);
      

      const { data } = await axios.patch(
        `https://parcharmanch-backend-7kc7.onrender.com/parcharmanch/updateBlog/${slug}`,
        form,
        { headers: { "Content-Type": "multipart/form-data" } }
      );


      // console.log("data",data);
      

      setPopup({
        open: true,
        type: data.success ? "success" : "error",
        message: data.message || "Something went wrong!",
      });
    } catch (err) {
      // console.error("Update error:", err);
      setPopup({
        open: true,
        type: "error",
        message: err?.response?.data?.message || "Something went wrong!",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <BlogUpdateContext.Provider
      value={{
        popup,
        setPopup,
        formData,
        setFormData,
        errors,
        setErrors,
        loading,
        handleInputChange,
        handleImageChange,
        handleEditorChange,
        handleAddContent,
        handleAddFAQ,
        handleUpdateBlog,
        setSlug,
        handleDeleteFAQ,
        handleDeleteContent,
        handleAltTextChange,
        refs,
      }}
    >
      {children}
    </BlogUpdateContext.Provider>
  );
};
